/**
 * Search Filters Module
 * Gestion interactive des filtres de recherche
 * Design Figma : 607-4605
 *
 * Fonctionnalités :
 * - Soumission automatique du formulaire (optionnel)
 * - Gestion des états actifs des filtres
 * - Accessibilité RGAA
 */

export default class SearchFilters {
  constructor() {
    this.form = document.querySelector('.search-form');
    this.filters = document.querySelectorAll('.search-form__filter select');
    this.searchInput = document.querySelector('.search-form__filter input[type="search"], .search-form__filter input[type="text"]');
    this.submitButton = document.querySelector('.search-form input[type="submit"], .search-form button[type="submit"]');

    if (this.form) {
      this.init();
    }
  }

  init() {
    // Empêcher la soumission automatique sur changement de filtre
    // L'utilisateur doit cliquer sur "OK" pour valider
    this.attachEventListeners();

    // Gérer l'état des filtres au chargement de la page
    this.updateFiltersState();
  }

  attachEventListeners() {
    // Événement sur les selects de filtres
    this.filters.forEach(filter => {
      filter.addEventListener('change', () => {
        this.highlightActiveFilters();
      });

      // Accessibilité : Annoncer les changements aux lecteurs d'écran
      filter.addEventListener('focus', () => {
        filter.setAttribute('aria-describedby', 'filter-instructions');
      });
    });

    // Validation sur soumission du formulaire (avant que Drupal le traite)
    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        // Validation : au moins un critère de recherche
        const hasSearchTerm = this.searchInput && this.searchInput.value.trim() !== '';
        const hasActiveFilter = Array.from(this.filters).some(filter => {
          return filter.value && filter.value !== '' && filter.value !== 'all';
        });

        if (!hasSearchTerm && !hasActiveFilter) {
          e.preventDefault();
          this.showErrorMessage('Veuillez saisir un terme de recherche ou sélectionner un filtre.');
          return false;
        }

        // Formulaire valide - laisser la soumission naturelle se faire
        // Drupal gérera la redirection avec les bons paramètres
      });
    }
  }

  /**
   * DEPRECATED: Cette fonction n'est plus utilisée.
   * La soumission se fait maintenant naturellement via le navigateur,
   * ce qui permet aux handlers PHP de Drupal de fonctionner correctement.
   */

  /**
   * Mettre en surbrillance les filtres actifs
   */
  highlightActiveFilters() {
    this.filters.forEach(filter => {
      if (filter.value && filter.value !== '' && filter.value !== 'all') {
        filter.classList.add('is-active');
        filter.setAttribute('aria-label', `Filtre actif : ${filter.options[filter.selectedIndex].text}`);
      } else {
        filter.classList.remove('is-active');
        filter.removeAttribute('aria-label');
      }
    });
  }

  /**
   * Mettre à jour l'état des filtres au chargement de la page
   * (après un retour arrière ou un rechargement)
   */
  updateFiltersState() {
    // Lire les paramètres de l'URL
    const urlParams = new URLSearchParams(window.location.search);

    // Restaurer les valeurs des filtres depuis l'URL
    this.filters.forEach(filter => {
      const filterName = filter.name;
      const filterValue = urlParams.get(filterName);

      if (filterValue) {
        filter.value = filterValue;
        filter.classList.add('is-active');
      }
    });

    // Restaurer le terme de recherche
    if (this.searchInput) {
      const searchKeys = urlParams.get('keys') || urlParams.get('query');
      if (searchKeys) {
        this.searchInput.value = searchKeys;
      }
    }

    this.highlightActiveFilters();
  }

  /**
   * Afficher un message d'erreur accessible
   */
  showErrorMessage(message) {
    // Créer ou mettre à jour le conteneur de message d'erreur
    let errorContainer = document.querySelector('.search-form__error');

    if (!errorContainer) {
      errorContainer = document.createElement('div');
      errorContainer.className = 'search-form__error';
      errorContainer.setAttribute('role', 'alert');
      errorContainer.setAttribute('aria-live', 'assertive');
      this.form.insertBefore(errorContainer, this.form.firstChild);
    }

    errorContainer.textContent = message;
    errorContainer.style.display = 'block';

    // Masquer le message après 5 secondes
    setTimeout(() => {
      errorContainer.style.display = 'none';
    }, 5000);

    // Focus sur le champ de recherche
    if (this.searchInput) {
      this.searchInput.focus();
    }
  }
}

// Initialisation automatique au chargement du DOM
document.addEventListener('DOMContentLoaded', () => {
  new SearchFilters();
});
